import styled from 'styled-components';
import { TextField as Field } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { colors } from '../../constants';

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  button {
    margin-top: 16px;
  }
`;

export const Anchor = styled(Link)`
  color: ${colors.red};
  margin-top: 32px;
  text-align: center;
  display: block;
`;

export const TextField = styled(Field)`
  width: 100%;
  margin: 8px 0 !important;
`;

export const ErrorText = styled.p`
  color: ${colors.red};
  text-align: center;
`;
